// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__h1OR6","buttons":"Footer_buttons__EO6DI"};